import { proxy } from "valtio";
import { RequesDetail, RequestList } from "../shared/models/requestList.model";
import { RequestDetails } from "../shared/models/request.model";
import { ChartData } from "../shared/models/chartData.model";

export const contentNetworkStore = proxy({
	requestFilters: {
		status: "all",
		network: "all",
		search: "",
		startDate:"",
		endDate: ""
	},
	requestList:{
		data: [],
		pagination: {
			currentPage: 1,
			offset: 0,
			pageSize: 20,
			hasNext: true,
			hasPrev: true
		}
	} as RequestList,
	requestSelected: -1,
	requestDetail:{processing:[], data:[]} as any,
	requestChart:[] as ChartData[],
	networkdDetail:[] as RequestDetails[],
	setRequestListAction: (value: any) => {
		contentNetworkStore.requestList = value;
	},
	changeRequestFilterAction: (key: string, value: string) => {
		contentNetworkStore.requestFilters[key as keyof typeof contentNetworkStore.requestFilters] = value.toLocaleLowerCase();
	},
	setRequestDetailAction: (key: keyof RequesDetail, value: RequestDetails[]) => {
		contentNetworkStore.requestDetail[key] = value;
	},
	setChartDataAction: (value: any) => {
		contentNetworkStore.requestChart = value;
	},
	selectRequestAction: (value: number) => {
		contentNetworkStore.requestSelected = value;
	},
	setNetworkDetailAction: (value: RequestDetails[]) => {
		contentNetworkStore.networkdDetail = value;
	}

});
